// @ts-nocheck


import React from 'react';

import Button from 'antd/lib/button';
import styled from 'styled-components';

import { Selects, Form } from './../../../components';
import { Section, Footer } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';

import CancelButton from './../../../components/CancelButton';



const SectionContent = styled.div.withConfig({ displayName: "InnerForm__SectionContent", componentId: "sc-tsrktu-0" })(["padding:16px;"]);



const { WashingVehicleTypeSelect, BrandsSelect, VehicleTypeSelect } = Selects;







export default ({ washingVehicleType, onSubmit, onCancel }) => {
  return (
    <Form initialValues={washingVehicleType} onSubmit={onSubmit}>
      {(FormField, formikProps) => {
        const { handleSubmit, dirty, setFieldValue, handleBlur } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <SectionContent>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField
                      label="Тип ТС для моек"
                      name="washingVehicleTypeId"
                      required
                      fast>

                      {({ name, value }) =>
                      <WashingVehicleTypeSelect
                        name={name}
                        value={value}
                        onChange={(value) =>
                        setFieldValue(name, value)
                        }
                        onBlur={() => handleBlur({ target: { name } })} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField label="Марка" name="brandId" required fast>
                      {({ name, value }) =>
                      <BrandsSelect
                        name={name}
                        value={value}
                        onChange={(value) =>
                        setFieldValue(name, value)
                        }
                        onBlur={() => handleBlur({ target: { name } })} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      label="Группа ТС"
                      name="vehicleGroup"
                      required
                      fast>

                      {({ name, value }) =>
                      <VehicleTypeSelect
                        onlyGroups
                        name={name}
                        value={value}
                        onChange={(value) =>
                        setFieldValue(name, value)
                        }
                        onBlur={() => handleBlur({ target: { name } })} />

                      }
                    </FormField>
                  </GridItem>
                </Grid>
              </SectionContent>
            </Section>
            <Footer>
              <Button type="primary" htmlType="submit" data-cy="save">
                Сохранить
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>);

      }}
    </Form>);

};
